<template>
  <div class="ChangePassword">
    <NotificationBar
      v-if="error"
      :message="error"
      level="error" />

    <div class="panel">
      <h1>Change password</h1>
      <template v-if="!didChange">
        <form @submit.prevent="change()">
          <div class="form-group">
            <label for="id-email">Email</label>
            <input
              id="id-email"
              type="email"
              v-model="email"
              disabled>

            <label for="id-password">New password</label>

            <div class="Input">
              <input
                v-if="!show"
                :class="{ error: hasError }"
                id="id-password"
                type="password"
                pattern=".{3,}"
                autocomplete="new-password"
                required
                title="minimum 3 charaters"
                v-model="password">

              <input
                v-if="show"
                :class="{ error: hasError }"
                id="id-password"
                autocomplete="new-password"
                pattern=".{3,}"
                required
                title="minimum 3 characters"
                type="text"
                v-model="password">
              <div
                class="show"
                @click="show = !show">
                <span v-if="show">hide</span>
                <span v-if="!show">show</span>
              </div>
            </div>

            <ul
              v-if="error"
              class="error">
              <li
                v-for="e of errors"
                :key="e">
                {{ e }}
              </li>
            </ul>
          </div>
          <button
            class="btn"
            type="submit">
            Change password
          </button>
          <template v-if="debug">
            Token: {{ token }}
          </template>
        </form>
      </template>
      <template v-if="didChange">
        <p>Password changed. You can now login with your new password.</p>
        <router-link to="login">
          Login
        </router-link>
      </template>
    </div>
  </div>
</template>

<script>
import NotificationBar from "@/components/NotificationBar";
export default {
  components: { NotificationBar },
  data: function () {
    return {
      error: "",
      didChange: false,
      show: false,
      email: "",
      password: "",
      token: "",
    };
  },

  props: {},

  mounted() {
    this.email = this.$route.query.email;
    this.token = this.$route.query.token;
  },

  computed: {
    debug() {
      return process.env.NODE_ENV === "development";
    },

    hasError() {
      return !!this.error;
    },
  },

  methods: {
    change() {
      this.error = "";
      this.errors = [];
      const payload = {
        email: this.email,
        token: this.token,
        password: this.password,
      };
      this.$store
        .dispatch("changePassword", payload)
        .then(() => (this.didChange = true))
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.message) {
            this.error = err.response.data.message;
            this.errors = err.response.data.errors || [];
          } else {
            this.error = err.message;
          }
        });
    },
  },

  filters: {},
};
</script>

<style lang="scss" scoped>
.ChangePassword {
  padding: 1em;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

button {
  width: 100%;
}

.panel {
  padding: 1em;
  justify-self: center;
  align-self: center;
}

h1 {
  text-align: center;
}

input.error {
  border-color: var(--pinkish-red);
}

ul.error {
  list-style: none;
  color: var(--pinkish-red);
}

.Input {
  display: flex;
  flex: 1;
  align-items: baseline;

  .show {
    color: var(--blue-purple);
    cursor: pointer;
    padding-left: 5px;
  }
}
</style>
